import type { Ref } from 'react';
import type { StackProps } from '@customerio/pluma-components/react';
import { FcmCredentialFields } from '@/features/push-credentials';

export type FcmFieldsViewProps = {
  file: File | null;
  savedFileName: string | null;
  isStoredKeyOffer: boolean;
  isEditing: boolean;
  canEdit: boolean;
  isBusy: boolean;
  isInvalid: boolean;
  fileError: string | null;
  ref?: Ref<HTMLDivElement>;
  onFileSelected: (file: File) => void;
} & StackProps;

/**
 * While iOS is offered the key Android already uses there is nothing to upload
 * here; uploading a different key is done from the Android tab.
 */
export function FcmFieldsView({
  file,
  savedFileName,
  isStoredKeyOffer,
  isEditing,
  canEdit,
  isBusy,
  isInvalid,
  fileError,
  onFileSelected,
  ...boxProps
}: FcmFieldsViewProps) {
  return (
    <FcmCredentialFields
      variant="settings"
      hasAndroidKey={isStoredKeyOffer}
      selectedFileName={file?.name ?? null}
      savedFileName={savedFileName}
      isEditable={isEditing && !isStoredKeyOffer}
      isInvalid={isInvalid}
      fileError={fileError ?? undefined}
      isDisabled={!canEdit || isBusy || !isEditing}
      onFileSelected={onFileSelected}
      {...boxProps}
    />
  );
}
